import type { SVGMotionProps } from "motion/react"
import { motion } from "motion/react"

import { cn } from "@productlane/lib/src/cn"

interface Props extends SVGMotionProps<SVGSVGElement> {
	percent: number
	thickness?: number
}

export const CircularProgress = ({
	percent,
	className,
	thickness = 20,
	...props
}: Props) => {
	const svgSize = 100
	const radius = (svgSize - thickness) / 2
	const percentPathLength = percent / 100
	const center = svgSize / 2

	return (
		<motion.svg
			width={svgSize}
			height={svgSize}
			viewBox="0 0 100 100"
			className={cn("stroke-gray-200 dark:stroke-gray-700", className)}
			{...props}
		>
			<motion.circle
				pathLength={1}
				className="origin-center -rotate-90 fill-transparent"
				style={{
					strokeWidth: `${thickness}px`,
					strokeLinecap: "round",
				}}
				cx={center}
				cy={center}
				r={radius}
			/>
			{percentPathLength > 0 && (
				<motion.circle
					initial={{
						pathLength: 0,
						opacity: 0,
					}}
					animate={{
						pathLength: percentPathLength,
						opacity: 1,
					}}
					transition={{
						pathLength: { type: "spring", duration: 1.5, bounce: 0 },
						opacity: { duration: 0.01 },
					}}
					className="origin-center -rotate-90 fill-transparent stroke-green-500"
					style={{
						strokeWidth: `${thickness}px`,
						strokeLinecap: "round",
					}}
					cx={center}
					cy={center}
					r={radius}
				/>
			)}
		</motion.svg>
	)
}
